var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0Z",
    fill: "#39A2DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13C7 12.4477 7.36377 12 7.8125 12H19.1875C19.6362 12 20 12.4477 20 13C20 13.5523 19.6362 14 19.1875 14H7.8125C7.36377 14 7 13.5523 7 13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7397 6.25628C14.0868 6.59799 14.0868 7.15201 13.7397 7.49372L8.14597 13L13.7397 18.5063C14.0868 18.848 14.0868 19.402 13.7397 19.7437C13.3925 20.0854 12.8297 20.0854 12.4826 19.7437L6.26035 13.6187C5.91322 13.277 5.91322 12.723 6.26035 12.3813L12.4826 6.25628C12.8297 5.91457 13.3925 5.91457 13.7397 6.25628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundBackIcon);
export default __webpack_public_path__ + "static/media/RoundBackIcon.c5f3af9e3561fe7250cc546d18d7ccb4.svg";
export { ForwardRef as ReactComponent };